// removed by extract-text-webpack-plugin
module.exports = {"navigation":"navigation__1EJRm","submenu_header":"submenu_header__de5ev","active":"active__3a8FO","submenu":"submenu__3ZsFV","open":"open__2lymk","history_links":"history_links__1QvYT","submenu_items":"submenu_items__1BtMd","submenu_dropdown":"submenu_dropdown__3YGUY","more_links":"more_links__ade6p"};


//////////////////
// WEBPACK FOOTER
// ./components/navigation/style.scss
// module id = +vFT
// module chunks = 13